<style lang="less" scoped>
    .container-page {
        min-height: 100%;
        position: relative;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: left top;
        &.banner{
            background-color: #f3f3f3;
            background-image:url("https://xcfs-public.xystatic.com/10074/mgm/mgm-one-bg.png");
        }
        &:before {
            content: '';
            display: block;
            height: 12.1rem;
        }
        .warn {
            position: absolute;
            top: .75rem;
            right: .75rem;
            font-size: 0.5rem;
        }
        .card-1, .card-2 {
            width: 100%;
        }
        .red-paper {
            width: 10.3rem;
            height: 1.1rem;
            margin: 0 auto;
            background: url("../img/red-paper.png") no-repeat 0 0;
            background-size: 100% auto;
            img{
                width: 100%;
                height: 100%;
            }
        }
        .invite-tip{
            width: 14rem;
            height: 1.75rem;
            position: absolute;
            margin: 0 auto;
            background: url("../img/msg.png") no-repeat 0 0;
            background-size: 100% auto;
            top: 13.4rem;
            right: 2.35rem;
            line-height: 1.75rem;
            color: #323449;
            padding-left: 3.5rem;
        }
        /*设置组件样式*/
        /deep/ .register {
            .form{
               width: auto;
               padding: 0 1.75rem;
                .input-box{
                    background-color: #F9FAFC;
                    .input{
                        border-radius:1.5rem;
                      background-color: transparent;
                    }

                    .send-sms-code{
                        color: #dd421c;
                    }
                }
              .inbox {
                background-color: #F9FAFC;
              }
              .in.mobile {
                background-color: transparent;
                border: 1px solid #F9FAFC;
              }
                .submit{
                    font-weight: bold;
                    border-radius: 1.5rem!important;


                }
                .agree-box{
                    margin-top: 0.2rem;
                  .checkbox-bg #agreement {
                    border-color: #EBEBEB;
                    background-color: #EBEBEB;
                  }
                    input:checked{
                        background-color:#fe7215!important; ;
                    }
                }

           }
            .content-box{
                .submit{

                }
            }
        }
        /deep/ .register-popup{

        }
        .bottom-img{
            width: 100%;
            >img{
                width: 100%;
            }
        }
        .bottom-warning-box {
            font-size: .6rem;
            color: #a0a0a0;
            padding: .75rem;

        }
        .copyright{
            color: #666;
            font-size: .5rem;
            text-align: center;
            padding-bottom: .5rem;
        }
        .ad-box{
            height: 2.75rem;
            width: 100%;
            position: relative;
            .ad {
                width: 100%;
                height: 2.75rem;
                background: url(../img/ad.png) no-repeat center;
                background-size: 100%;
                position: fixed;
                left: 0;
                bottom: 0;
                z-index: 10;
                .ad-close {
                    height: 1rem;
                    width: 1rem;
                    position: absolute;
                    left: .8rem;
                    top:1rem ;
                }
                .ad-download {
                    position: absolute;
                    right: 0;
                    height: 2.75rem;
                    width: 4.5rem;
                    z-index: 99;
                    top: 0;
                }
            }
        }
    }

</style>
<template>
    <div class="container-page clear" :class="{banner: view&&!config.bgImgUrl}" :style="styleObject.page">
        <div class="warn" :style="styleObject.warn" v-html="extend.warning_text"></div>
        <div class="red-paper" v-if="config.cardConfig == 2"></div>
        <div class="invite-tip number" v-if="inviteTip">{{inviteTip}}</div>
        <!--支付平铺注册 view兼容历史状态-->
        <pay-register class="register" v-if="view == 3||view == 1" :config="config" prefixPage="kadaimgmfanxian_" @regDone="done" @regFail="fail"></pay-register>
        <!--支付弹窗注册  4自动注册弹窗-->
        <pay-reg-popup class="register-popup" v-if="view == 2 || view == 4" :config="config" prefixPage="kadaimgmfanxian_" @regDone="done" @regFail="fail"></pay-reg-popup>
        <div class="bottom-img" v-if="config.bottomImgUrl && config.bottomImgUrl.length">
            <img v-for="item in config.bottomImgUrl" :src="item" :key="item" alt="">
        </div>
        <div class="bottom-warning-box" :style="styleObject.bottomWarningBox">
            <p class="warning-title">温馨提示：</p>
            <p class="bottom-warning" v-html="extend.bottom_warning"></p>
        </div>
        <div :style="styleObject.copyright" class="copyright" v-html="config.bottomCharacters">

        </div>
        <div class="ad-box" v-if="extend.ad&&extend.ad!=0 && showDownloadFlag">
            <div class="ad" >
                <div @click="showDownloadFlag = false" class="ad-close"></div>
                <div @click="download" class="ad-download"></div>
            </div>
        </div>
    </div>
</template>
<script>
  import { getOpenId } from '@/component/utils/bindWechat'
  import { mapState } from 'vuex'
  import getQueryString from 'bjxy-common/helper/getQueryString'
  import getQueryJson from 'bjxy-common/helper/getQueryJson'
  import addUrlQuery from 'bjxy-common/helper/addUrlQuery'
  import { parse, extend, realType } from 'bjxy-common/helper/utils'
  import transfromType from 'bjxy-common/helper/transfromType'
  import payRegister from '@/component/payRegister'
  import payRegPopup from '@/component/payRegPopup'
  import mixinFun from 'bjxy-common/vuePlugin/mixins'
  import wxShare from 'bjxy-common/xyHelper/wxShare'
  import defaultConfig from '../config'
  import api from '../api'
  import { regEventInit, regEventPush } from '@/component/utils/regEvent'
  import maskMobile from 'bjxy-common/filters/maskMobile'
  import getBrowserInfo from 'bjxy-common/helper/getBrowserInfo';
  import API from '@/component/utils/api'
  import replaceDomain from 'bjxy-common/xyHelper/replaceDomain'
  const ua = getBrowserInfo();

  const mixin = mixinFun({
    testRule: [
      {
        key: 'channelId'
      },
      {
        key: 'landId'
      }
    ]
  })

  export default {
    name: 'mgm',
    data () {
      return {
        showDownloadFlag: true,
        source: getQueryString('source'),
        landId: getQueryString('landId'),
        view: 0,
        config: defaultConfig,
      }
    },
    computed: {
      ...mapState(['pageTitle']),
      extend () {
        return this.config.extend || {}
      },
      regSuccRedirect(){
        if(ua.ios){
          return this.extend.iosRegSuccUrl || this.config.regSuccRedirect;
        }else if(ua.android){
          return this.extend.androidRegSuccUrl || this.config.regSuccRedirect;
        }else{
          return this.config.regSuccRedirect;
        }
      },
      regType () {
        return this.extend.regType - 0
      },
      productType () {
        return this.extend.productType - 0
      },
      params () {
        return {
          source: this.source,
          landId: this.config.landId,
          partner_data: getQueryString('partner_data'),
          fromUrl: encodeURIComponent(location.href.split('#')[0])
        }
      },
      styleObject(){
        return {
          page:{
            backgroundImage: this.config.bgImgUrl?`url(${this.config.bgImgUrl})`: null,
            backgroundColor: this.extend.bg_color,
            paddingTop: this.extend.banner_h
          },
          warn:{
            color: this.extend.warning_color,
            fontSize: this.extend.warning_size
          },
          bottomWarningBox:{
            color: this.extend.bottom_warning_color
          },
          copyright:{
            color:this.extend.copy_color
          }
        }
      },
      inviteTip(){
        var mobile = getQueryString('inviteMobile')
        if(mobile){
          return `好友${maskMobile(mobile)}给您送福利啦`
        }
        return ''
      }
    },
    created () {
      this.getConfig()
    },
    mixins: [mixin],
    methods: {
      getConfig () {
        var params = {
          channelId: this.source,
          landId: this.landId
        }
        if (!this.test(params, true)) {
          this.init()
          return
        }
        this.post(API.LANDING_PAGE_INFO, params, {
          headers: {
            'X-App-Code': 'xy_cardloan'
          }
        }).then(json => {
          var config = json.data
          if (config.redirectUrl) {
            var json = getQueryJson()
            delete json.landId
            var redirectUrl = addUrlQuery(config.redirectUrl, json)
            return location.replace(replaceDomain(redirectUrl))
          }
          this.config = this.configFormat(config)
          this.init()
        }, json => {
          this.toast(json.errstr)
          this.init()
        })
      },
      configFormat (config) {
        var extendData = parse(config.extend)
        if (realType(extendData) !== 'object') {
          extendData = {}
        }
        config.extend = extendData
        config = extend(defaultConfig, config)
        config.extend = transfromType(config.extend, {productType: Number, regType: Number})
        return config
      },
      init () {
        this.view = this.regType;
        var softid = this.productType ==1? 6:5; // 默认卡贷softid 5
        this.reportInit({softid: softid})
        this.commit('pageTitle', {pageTitle: this.extend.title})
        regEventInit(this.config)
        if(this.extend.isGetWXUnionid == '1'){
          getOpenId.call(this)
        }
        wxShare({
          title: this.extend.wxShareTitle,
          content: this.extend.wxShareContent,
          link: location.href,
          picUrl: this.extend.wxShareIconUrl,
        })
      },
      done (json) {
        // 注册成功
        regEventPush()
        this.toast("注册成功，正在为您跳转...",2000,()=>{
          location.href = addUrlQuery(replaceDomain(this.regSuccRedirect), this.params)
        })
      },
      fail (json) {
        // 注册失败
        this.toast(json.errstr)
      },
      download(){
        var url = api.NEW_DOWNLOAD_LINK
        if(this.extend.ad == 2){
          url = api.YYB_DOWNLOAD_LINK
        }
        location.href = addUrlQuery(replaceDomain(url),this.params)
      }

    },
    components: {
      payRegPopup,
      payRegister
    }
  }
</script>
